import React, { useEffect } from 'react'
import moment from 'moment'

import { Box, Grid, Typography } from '@material-ui/core'

import { Place } from 'src/api/models'
import { Barcode } from '../Barcode'

interface Props {
  obj: Place
  onReadyToPrint?: () => void
}

export const PlaceLabel = (props: Props) => {
  const { obj, onReadyToPrint } = props
  const barcode = { barcode: obj.guid, type: 'datamatrix', displayName: '' }

  useEffect(() => {
    onReadyToPrint?.()
  }, [onReadyToPrint])

  return (
    <div className="always-page-break">
      <Box pl={5} pt={5} className="print-page">
        <Grid container justify="center" alignItems="center" spacing={2}>
          <Grid item container xs={12} spacing={2}>
            <Grid item xs={4}>
              <Barcode barcode={barcode} />
            </Grid>
            <Grid item xs={8} container alignItems="center" justify="center">
              <Grid item xs={12}>
                <obj.icon fontSize="large" />
              </Grid>
              <Grid item xs={12}>
                <Typography variant="h1">{obj.shortPath}</Typography>
                <Typography variant="h1">{obj.name}</Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h3">{obj.guid}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h5">{obj.path}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography>Printed on {moment().format('lll')}</Typography>
          </Grid>
        </Grid>
      </Box>
    </div>
  )
}
